import SLOT_STATUSES from '../../constants/slotStatuses';

/**
 * Slot predicates for the per-shift actions (Guarantee, Invite, Add Slots
 * badge) on the global schedule and the daily schedule. Actions derive their
 * slot lists from the raw shift data kept on routeData (rawShift on the global
 * schedule, rawSlots on the daily schedule) so they see the full shift
 * regardless of the active display filters; these predicates are the single
 * definition of which raw slots count as cancelled/open.
 *
 * Each routeData entry targets exactly one shift — the one its
 * shiftId names. When a card merges a second shift of the same type, that
 * shift keeps its own state and is deliberately outside the entry's scope.
 *
 * Global schedule slots carry the raw status code in slot_status; daily
 * schedule feed rows carry the is_cancelled flag instead.
 */
export const isCancelledSlot = (slot) => !!slot.is_cancelled || slot.slot_status === SLOT_STATUSES.FACILITY_CANCELLED;

export const isOpenSlot = (slot) => !isCancelledSlot(slot) && !slot.caregiver_id;
